<template>
    <div>
        <slot>
            <ui-button 
                :disabled="disabled"
                icon="attach_file" 
                style="width: 100%; margin-bottom: .5rem; justify-content: left;"
                @click="$refs.intray.open()"
            >Images / Docs</ui-button>
        </slot>

        <document-management-modal
            ref="intray"
            :accept="AcceptedDocumentMimes"
            :model-type="DocumentOwnerType.Task"
            :model-id="task.id"
            :default-type="DocumentTypes.TYPE_TASK_DOCUMENT"
            :descriptions="descriptions"
            @saved="handleFileSelect"
        ></document-management-modal>
    </div>
</template>

<script>
import {DocumentDescriptionList, DocumentResource, DocumentTypes} from '../../../classes/Api/Document'
    import InTrayModal from '../../elements/InTrayModal'
    import DocumentManagementModal from "../../elements/DocumentManagementModal.vue";
import {DocumentOwnerType, DocumentType} from "../../../../../api-clients/ts";
import DealerKit from "../../../api";
import {AcceptedDocumentMimes} from "../../../../ts/DocumentPaneMimes";

    export default {
        components: {
            DocumentManagementModal,
            InTrayModal
        },
        data() {
            return {
                DocumentTypes,
                AcceptedDocumentMimes,
            }
        },
        props: {
            isLoading: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            task: {
                type: Object,
                required: true,
            },
            disabled: {
                type: Boolean,
                default() {
                    return false;
                }
            }
        },
        computed: {
            DocumentOwnerType() {
                return DocumentOwnerType
            },
           descriptions() {
                return [DocumentDescriptionList[DocumentDescriptionList.length - 1]]
            },
        },
        methods: {
            handleFileSelect(documents) {
                documents = documents.toAssociate.map((document, i) => {
                    return {
                        id: document.id,
                        type: DocumentType.TaskDocument,
                        description: 'Job Document',
                        order: i
                    }
                })

                DealerKit.documents.associateDocuments({
                    owner_type: DocumentOwnerType.Task,
                    owner_id: this.task.id,
                    documents
                }).then(() => {
                    this.$emit('updated')
                })
            }
        }
    }
</script>